import styled from "@emotion/styled";
import { useHistory } from "react-router";

import { TableRow } from "../../../UI/TableRow";
import { Typography } from "../../../UI/Typography";
import { COLOR_SCIENCE_BLUE } from "../../../constants/styles";
import { alpha } from "@mui/system/colorManipulator";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from "../../../components/Link";
import { PORTFOLIO_LIST } from "./PortfolioList";
import { PORTFOLIO_DETAILED } from "./PortfolioDetailedView";

export const StyledTableRow = styled(TableRow)`
  &:not([disabled]) {
    cursor: pointer;

    &:hover,
    &:focus {
      background-color: ${alpha(COLOR_SCIENCE_BLUE, 0.2)} !important;
    }
  }
`;

export const useGetBreadcrumbs = (portfolio?: any, network?: any) => {
  const { replace } = useHistory();

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <Link
        underline="hover"
        color={COLOR_SCIENCE_BLUE}
        onClick={() => { replace(PORTFOLIO_LIST); }}
      >
        <b>Portfolios</b>
      </Link>
      {
        !network
          ? (
            <Typography color='black'>
              <b>{portfolio?.name}</b>
            </Typography>
          ) : (
            <Link
              underline="hover"
              color={COLOR_SCIENCE_BLUE}
              onClick={() => { replace(PORTFOLIO_DETAILED.replace(":portfolioId", portfolio?.id)); }}
            >
              <b>{portfolio?.name}</b>
            </Link>
          )
      }
      {
        network
          ? (
            <Typography color='black'>
              <b>{network?.name}</b>
            </Typography>
          ) : null
      }
    </Breadcrumbs>
  );
};
